module.exports = false;


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0